<template>
  <DpplSegmentedToggle
    :model-value="modelValue"
    :options="frequencyOptions"
    :aria-label="ariaLabel"
    @update:model-value="emit('update:modelValue', $event)"
  />
</template>

<script setup>
import DpplSegmentedToggle from '@/components/datapeople/DpplSegmentedToggle.vue';

defineProps({
  modelValue: {
    type: String,
    default: 'none',
    validator: (value) => ['none', 'weekly', 'monthly'].includes(value),
  },
  ariaLabel: {
    type: String,
    default: 'Frequency',
  },
});

const emit = defineEmits(['update:modelValue']);

const frequencyOptions = [
  { value: 'none', label: 'None' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
];
</script>
